<template>
  <div class="block-info" id="promotion-info">
    <bimContainer>
      <bimCol cols=12 md=10 class="mx-auto">
        <BimSteps
          class="mt-11"
          :title="$t(`Тариф <span class='primary-color'>Единый</span> — предоставим ценнейшую информацию для вашего отдела продаж и маркетинга`)"
          :slides="steps_tariff"
        />
        <div class="block-info__tariff p-11 mb-12 mt-12 d-flex flex-column align-center">
          <bim-text type=accent bold>Подключите тариф <span class='primary-color'>Единый</span></bim-text>

          <div class="d-flex flex-column flex-sm-row mt-10">
            <div class="d-flex align-end">
              <div class="tariff-price__wrapper">
                <div class="d-flex align-end">
                  <bim-text type=main class="tariff-price__number">90 000</bim-text>
                  <bim-text type=accent bold class="tariff-price__symbol pl-2 pb-3">₽</bim-text>
                </div>
                <bim-text type=main bold>за год</bim-text>
              </div>
            </div>
          </div>

          <ButtonLeaveRequest class="mt-11 mb-9" @click="$emit('leaveRequest', 'Запрос на подключение тарифа Единый')" />

          <noindex>
            <bim-text type=main class="opacity75">
              При помесячной оплате годовой подписки 10 500 р в месяц
            </bim-text>
          </noindex>

        </div>
        <div class="faq-dropdown mb-9" data-dropdown-wrapper>
          <div class="faq-dropdown_top" data-dropdown-title>
            <bim-text type=h5 bold class="faq-dropdown_title">{{ $t('Доступно на всех тарифах') }}</bim-text>
            <i class="icon-dropdown-light"></i>
          </div>
          <div class="faq-dropdown_content">
            <BimSteps
              :slides="steps_free"
            />
          </div>
        </div>
        <div class="tariff__delimiter mb-8"></div>
      </bimCol>
    </bimContainer>
  </div>
</template>

<script>
import ButtonLeaveRequest from "./ButtonLeaveRequest"
import BimSteps from "@/components/BimSteps"
import bimCol from "@bimlib/components/bimCol"
import bimContainer from "@bimlib/components/bimContainer"
export default {
  inject: ["imgPath"],
  name: "BlockInfo",
  components: {
    ButtonLeaveRequest,
    BimSteps,
    bimCol,
    bimContainer,
  },
  data() {
    return {
      steps_free: [
        {
          title: this.$t("Страница с информацией о вашей компании"),
          img: `${this.imgPath}/steps/free-1@3x.jpg`
        },
        {
          title: this.$t("Размещение цифровых каталогов, BIM- и AR-моделей в библиотеке BIMLIB"),
          img: `${this.imgPath}/steps/free-2@3x.jpg`
        },
        {
          title: this.$t("Индивидуальные разделы в вашем каталоге"),
          img: `${this.imgPath}/steps/free-3@3x.jpg`
        },
        {
          title: this.$t("Доступность всех моделей в плагине BIMLIB для САПР"),
          img: `${this.imgPath}/steps/free-4@3x.jpg`
        },
        {
          title: this.$t("Публикация собственных плагинов для САПР"),
          img: `${this.imgPath}/steps/free-5@3x.jpg`
        },
        {
          title: this.$t("Статистика просмотров и скачиваний"),
          img: `${this.imgPath}/steps/free-7@3x.jpg`
        },
        {
          title: this.$t("Возможность встраивания библиотеки на сторонних сайтах (embed код)"),
          img: `${this.imgPath}/steps/free-6@3x.jpg`
        },
      ],
      steps_tariff: [
        {
          title: this.$t("Контакты инженеров и проектировщиков, скачавших BIM-модели вашей продукции"),
          img: `${this.imgPath}/steps/premium-1@3x.jpg`
        },
        {
          title: this.$t("Контакты ЛПР на строительных площадках"),
          img: `${this.imgPath}/steps/premium-2@3x.jpg`
        },
        {
          title: this.$t("Информация об актуальных строящихся объектах и потребностях в строительных материалах"),
          img: `${this.imgPath}/steps/premium-3@3x.jpg`
        },
        {
          title: this.$t("Блог компании в Читальном зале — ваши материалы увидят десятки тысяч проектировщиков"),
          img: `${this.imgPath}/steps/premium-4@3x.jpg`
        },
        {
          title: this.$t("Размещение видеороликов на странице модели"),
          img: `${this.imgPath}/steps/premium-5@3x.jpg`
        },
        {
          title: this.$t("Личный аккаунт-менеджер"),
          img: `${this.imgPath}/steps/premium-7.svg`
        },
        {
          title: this.$t("Cкидка 3% на заказ BIM- и AR-моделей в период действия оплаченного тарифа"),
          img: `${this.imgPath}/steps/premium-6.svg`
        },
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";
::v-deep .primary-color {
  color: $primary-color;
}

.opacity75 {
  opacity: .75;
}

.block-info {
  padding: 64px 0 44px;

  .block-info__tariff {
    max-width: 1160px;
    background-color: $primary-color-75;
    margin: auto;
    border-radius: 8px;

    .tariff-price__wrapper {
      text-align: right;
    }
    .tariff-price__number {
      font-size: 50px;
      line-height: 1.18;
    }
  }

  .icon-dropdown-light {
    font-size: 11px;
    &::before {
      color: $black-color;
      font-weight: bold;
    }
  }
  .tariff__delimiter {
    height: 1px;
    border-top: 1px solid $white-color-600;
    width: 100%;
  }
}
</style>
